import React, { useEffect, useCallback, useState } from "react";
import { StatusBar } from "expo-status-bar";
import Navigation from "./src/navigation/Navigation";
import Notification from "./src/components/Notification/Notification";
import { PaperProvider, Button, Text } from "react-native-paper";
import AwesomeIcon from "@expo/vector-icons/FontAwesome5";
import { useFonts } from "expo-font";
import KeyboardAvoidingWrapper from "./src/components/Containers/KeyboardAvoidingWrapper";
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { AuthProvider } from "./src/context/Auth/AuthContext";
import { TimeTrackingProvider } from "./src/context/TimeTracking/TimeTrackingContext";
import { SheetProvider } from "react-native-actions-sheet";
import "./global.css";

export default function App() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [fontsLoaded, fontError] = useFonts({});
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  useEffect(() => {
    const checkInstallPromptDismissed = async () => {
      const dismissed = await AsyncStorage.getItem("installPromptDismissed");
      if (Platform.OS === "web" && !dismissed) {
        window.addEventListener("beforeinstallprompt", (e: any) => {
          e.preventDefault();
          setDeferredPrompt(e);
          setShowInstallPrompt(true);
        });
      }
    };
    checkInstallPromptDismissed();
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`User response to install prompt: ${outcome}`);
      setDeferredPrompt(null);
      setShowInstallPrompt(false);
      await AsyncStorage.setItem("installPromptDismissed", "true");
    }
  };

  const handleDismiss = async () => {
    await AsyncStorage.setItem("installPromptDismissed", "true");
    setShowInstallPrompt(false);
  };

  const onLayoutRootView = useCallback(async () => {
    if (fontsLoaded || fontError) {
      // ready to render
    }
  }, [fontsLoaded, fontError]);

  if (!fontsLoaded && !fontError) return null;

  return (
    <AuthProvider>
      <SheetProvider>
        <TimeTrackingProvider>
          <PaperProvider
            settings={{
              icon: (props) => <AwesomeIcon {...props} />,
            }}
          >
            <StatusBar style="light" />
            {/* Install Prompt UI for Web */}
            {Platform.OS === "web" && showInstallPrompt && (
              <Notification
                title="Install Time Tracker App?"
                message="Add the Time Tracker app to your home screen for a better experience."
                type="info"
                actions={
                  <>
                    <button
                      onClick={handleInstall}
                      className="text-sm font-medium text-white bg-blue-600 px-3 py-1 rounded hover:bg-blue-700"
                    >
                      Install
                    </button>
                    <button
                      onClick={handleDismiss}
                      className="text-sm font-medium text-gray-500 hover:text-gray-700"
                    >
                      Maybe later
                    </button>
                  </>
                }
              />
            )}
            {/* {isLoading ? <HomeSplashScreen setIsLoading={setIsLoading}/>: <LoginScreen/>}  */}

            <KeyboardAvoidingWrapper>
              <Navigation />
            </KeyboardAvoidingWrapper>
          </PaperProvider>
        </TimeTrackingProvider>
      </SheetProvider>
    </AuthProvider>
  );
}
